// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-field-read-only {
  margin-bottom: 0;
  word-wrap: break-word;
}
.c-field-read-only label {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/common/FieldReadOnly/style.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,qBAAA;AACF;AAAE;EACE,gBAAA;AAEJ","sourcesContent":[".c-field-read-only {\r\n  margin-bottom: 0;\r\n  word-wrap: break-word;\r\n  label {\r\n    font-weight: 500;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
